const breakpointEl = document.querySelector("#breakpoints");

// Null when the #breakpoints sentinel is absent from the DOM for any reason,
// so both checks report false rather than throwing on getComputedStyle(null).
const breakpointZIndex = () => (breakpointEl ? getComputedStyle(breakpointEl).zIndex : null);

const isAboveBreakpoint = () => 2 == breakpointZIndex();

const isBelowBreakpoint = () => 1 == breakpointZIndex();

export { isAboveBreakpoint, isBelowBreakpoint };
